<template>
  <div class="filter__initial">
    <FiltersLocations
      :deleteSubRegions="deleteSubRegions"
      :disableSubRegionDropdown="disableSubRegionDropdown"
      :isTab2="isTab2"
      :locations="locations"
      :selectedRegionID="selectedRegion"
      :selectedSubRegions="selectedSubRegions"
      :subRegionsForRegion="subRegionsForRegion"
      :updateRegion="updateRegion"
      :updateSubRegions="updateSubRegions"
      name="regionID"
    ></FiltersLocations>
    <div class="filters__initial-button-wrapper">
      <div v-if="isTab2"></div>
      <div v-else>
        <button
          aria-label="Toggle optional filters"
          @click="toggleShowOptions"
          class="button button-tertiary filters__show-filters"
        >
          View more filters
          <span class="icon icon-filters"></span>
        </button>
      </div>
      <FiltersApplyButton
        :APICall="APICall"
        :applyFiltersText="applyFiltersText"
        :isTab2="isTab2"
        :updateShowOptions="updateShowOptions"
      ></FiltersApplyButton>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import FiltersLocations from "./FiltersLocations.vue";
import FiltersApplyButton from "./FiltersApplyButton.vue";

export default Vue.component("FiltersInitial", {
  props: {
    APICall: Function,
    applyFiltersText: String,
    applyFiltersToAPICall: Function,
    deleteSubRegions: Function,
    disableSubRegionDropdown: Boolean,
    isTab2: Boolean,
    locations: Array,
    optionalExpanded: Boolean,
    selectedRegion: Array,
    selectedSubRegions: Array,
    subRegionsForRegion: Array,
    updateRegion: Function,
    updateShowOptions: Function,
    updateSubRegions: Function,
  },
  components: {
    FiltersApplyButton,
    FiltersLocations,
  },
  methods: {
    toggleShowOptions: function() {
      let x = this.optionalExpanded;
      this.updateShowOptions(!x);
    },
  },
});
</script>
